module.exports = __webpack_public_path__ + "img/27.a51c55a7.jpg";